// extracted by mini-css-extract-plugin
export var backgroundColor = "QuienesSomos-module--backgroundColor--3H6w6";
export var h3 = "QuienesSomos-module--h3--F72Uy";
export var metodologiaContainer = "QuienesSomos-module--metodologiaContainer--6X1px";
export var metodologiaItem = "QuienesSomos-module--metodologiaItem--UPrKX";
export var misionVisionContainer = "QuienesSomos-module--misionVisionContainer--7ndHW";